var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.base.tableHeading]},[_c('div',{class:[_vm.base.fieldName]},[_vm._t("default",[_vm._v("Add a heading!")])],2),_c('div',{class:[_vm.base.fieldDesc]},[_vm._t("tooltip")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }